<div class="container mx-auto device-content">
    <div class="hero-text" fxLayout="row" fxFlexAlign="center">
        <h1 style="font-weight:800;">{{'ENVANTER'|translate}} {{'UPDATE'|translate}}</h1>
    </div>
    <form #envanterForm="ngForm" (ngSubmit)="envanterForm.form.valid" novalidate>
        <div fxLayout="row wrap" fxFlexAlign="center">
            <div fxFlex="100" fxLayout="column" fxLayoutAlign="space-evenly start">
                <mat-form-field fxFlex="100" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'NAME'|translate}}</mat-label>
                    <input name="name" matInput placeholder="{{'NAME'|translate}}" [(ngModel)]="envanter.name" required>
                </mat-form-field>
                <mat-form-field fxFlex="100" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'TYPE'|translate}}</mat-label>
                    <input name="type" matInput placeholder="{{'TYPE'|translate}}" [(ngModel)]="envanter.type" required>
                </mat-form-field>
                <mat-form-field fxFlex="100" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'DESCRIPTION'|translate}}</mat-label>
                    <input name="description" matInput placeholder="{{'DESCRIPTION'|translate}}" [(ngModel)]="envanter.description"
                        required>
                </mat-form-field>
                <mat-form-field *ngIf="companyId==1" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'COMPANY'|translate}}</mat-label>
                    <mat-select [(ngModel)]="selectedCompany" placeholder="{{'COMPANY'|translate}}" required
                        name="companies">
                        <mat-option *ngFor="let item of companyList" name="copaniesOptions" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="firmware-file-input">
                    <form enctype="multipart/form-data">
                        <input (change)="fileChange($event.target.files)" accept=".png,.jgp,.jpeg,.svg" type="file"
                            placeholder="Basic outline placeholder">
                    </form>
                </div>
            </div>
            <button style="margin-top: 10px;" mat-raised-button (click)="submit(envanterForm)">
                <span>{{'CREATE'|translate}}</span>
            </button>
        </div>
    </form>

</div>